import { render, staticRenderFns } from "./PCMethod.vue?vue&type=template&id=0a528dc7&scoped=true&"
import script from "./PCMethod.vue?vue&type=script&lang=js&"
export * from "./PCMethod.vue?vue&type=script&lang=js&"
import style0 from "./PCMethod.vue?vue&type=style&index=0&id=0a528dc7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a528dc7",
  null
  
)

export default component.exports